export const BLACK_BLURHASH = '000cGy'
